import { createApi } from '@reduxjs/toolkit/query/react';

import { WithCurrenciesApiResponse } from '@mint-lib/currencies-helpers';
import { formCustomRTKQueryError } from '@mint-lib/rtk-query-client';

import {
  CurrencyItemRaw,
  CurrencyRatePayload,
  CurrencyRateResponse,
} from '../redux/reducer/campaigns/types.js';
import { axiosBaseQuery } from './apiSlice.js';

const BASE_URL = '/api/currency/v1/';

export const currenciesApi = createApi({
  reducerPath: 'currenciesApi',
  baseQuery: axiosBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getCurrencies: builder.query<
      WithCurrenciesApiResponse<CurrencyItemRaw[]>,
      void
    >({
      query: () => ({
        url: 'currencies/',
      }),
      transformErrorResponse: () => {
        return formCustomRTKQueryError({
          snackbarOptions: { skipAppearance: true },
        });
      },
    }),
    getCurrencyRate: builder.query<CurrencyRateResponse, CurrencyRatePayload>({
      query: (data) => ({
        url: 'exchange_rates/rate/',
        method: 'POST',
        data,
      }),
      transformErrorResponse: () => {
        return formCustomRTKQueryError({
          snackbarOptions: { skipAppearance: true },
        });
      },
    }),
  }),
});

export const { useGetCurrenciesQuery, useLazyGetCurrencyRateQuery } =
  currenciesApi;
